import React, { FC, useContext, useEffect, useState } from "react";

import { Link } from "capitalrx-components-2.0/lib/general";
import { Grid, Stack } from "capitalrx-components-2.0/lib/layout";
import { Heading } from "capitalrx-components-2.0/lib/typography";

import { LoginButton } from "@/components";
import { ThemeSelectorContext } from "@/context";
import { getThemeURL, isPrime } from "@/utils";

import judiLogoCompressed from "@/static/logos/judi-compressed-white.png";


import styles from "./HeaderActionBar.module.scss";


export const HeaderActionBar: FC = () => {
  const { banner_gradient, header_text_color, logo } = useContext(ThemeSelectorContext);

  const [screenSize, setScreenSize] = useState<"mobile" | "tablet" | "desktop">("desktop");

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 400) {
        setScreenSize("mobile");
      } else if (window.innerWidth <= 900) {
        setScreenSize("tablet");
      } else {
        setScreenSize("desktop");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const showHeading = screenSize === "desktop";
  const showFullLogo = screenSize === "desktop" || screenSize === "tablet";
  return (
    <Grid
      className={styles.HeaderActionBarContainer}
      style={{ "--banner-gradient": banner_gradient } as React.CSSProperties}
    >
      <Grid.Span columns={4}>
        <Stack alignment="left">
          {showFullLogo && (
            <img src={logo.url} style={{ height: "24px", width: "284px" }} />
          )}
          {!showFullLogo && (
            <img src={judiLogoCompressed} style={{ height: "32px", width: "32px" }} />
          )}
        </Stack>
      </Grid.Span>
      <Grid.Span columns={4}>
        <Stack alignment="center">
          {showHeading && (
            <Link to={getThemeURL("HOME")} style={{ color: header_text_color, textDecoration: "none" }}>
              <Heading>Health Care Portal</Heading>
            </Link>
          )}
        </Stack>
      </Grid.Span>
      <Grid.Span columns={4}>
        <Stack alignment="right">
          {!isPrime && <LoginButton />}
        </Stack>
      </Grid.Span>
    </Grid>
  );
};
